import { IconBox } from "../icon/variants/IconBox.js";
import { Flex } from "../mantine-passthroughs/index.js";
import { Body1 } from "../typography/Body1.js";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/delivery/Delivery.tsx
/**
* A flexible component to display delivery information
*/
const Delivery = ({ iconColor = "primary", showIcon = true, shippingTime, "data-testid": testId }) => {
	return /* @__PURE__ */ jsxs(Flex, {
		align: "center",
		gap: "xxs",
		"data-testid": testId,
		children: [showIcon && /* @__PURE__ */ jsx(IconBox, { color: iconColor }), /* @__PURE__ */ jsx(Body1, { children: shippingTime })]
	});
};

//#endregion
export { Delivery };